export const MEMBER_TYPE = "member_type";
export const MEMBER_ID = "member_id";
export const ACCOUNT_TYPE = "account_type";
export const ACCOUNT_ID = "account_id";
export const LOGIN_STATUS = "login_status";
export const HASHED_MAIL = "HASHED_MAIL";
